module.exports = "./img/a56a404880691bb89c28bc9a38012da9.jpg";